export class DropdownModel {
    id: number;
    value: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/dropdown-model.ts